// extracted by mini-css-extract-plugin
export default {"container":"VerticalHeaderImageCard_container__MeyVa","photo":"VerticalHeaderImageCard_photo__8Kx4h"};